import {
  buildMiniProgramUrl,
  type WxUrlData,
} from "@/api/message/common/MessageParser";
import { toast } from "sonner";

interface WxNavigateOptions {
  url: string;
  success?: () => void;
  fail?: (err: { errMsg: string }) => void;
}

interface WxNavigateBackOptions {
  delta?: number;
  success?: () => void;
  fail?: (err: { errMsg: string }) => void;
}

interface WxMiniProgram {
  getEnv: (cb: (res: { miniprogram: boolean }) => void) => void;
  navigateTo: (options: WxNavigateOptions) => void;
  switchTab: (options: WxNavigateOptions) => void;
  navigateBack: (options: WxNavigateBackOptions) => void;
}

function getWxMiniProgram(): WxMiniProgram | undefined {
  const wx = (window as Window & { wx?: { miniProgram?: WxMiniProgram } }).wx;
  return wx?.miniProgram;
}

function runInMiniProgram(
  mp: WxMiniProgram,
  action: () => void,
): void {
  mp.getEnv((res) => {
    console.log("[wxurl] 运行环境", res);

    if (!res.miniprogram) {
      toast.error("请在微信小程序中打开后使用");
      console.warn("[wxurl] 当前不在微信小程序环境中");
      return;
    }

    action();
  });
}

export function redirectToMiniProgram(wxUrl: WxUrlData): void {
  const { path, params = {}, type } = wxUrl;
  const pathOnly = buildMiniProgramUrl(path, {});
  const url = buildMiniProgramUrl(path, params);
  const mp = getWxMiniProgram();

  console.log("[wxurl] 按钮点击", { name: wxUrl.name, type, path, params, url });

  if (!mp?.getEnv) {
    toast.error("请在微信小程序中打开后使用");
    console.warn("[wxurl] wx.miniProgram 不可用");
    return;
  }

  if (type === "tabBar") {
    runInMiniProgram(mp, () => {
      console.log("[wxurl] 调用 switchTab", pathOnly);
      mp.switchTab({
        url: pathOnly,
        success: () => console.log("[wxurl] switchTab 成功", pathOnly),
        fail: (err) => {
          console.error("[wxurl] switchTab 失败:", err.errMsg);
          toast.error("跳转失败，请稍后重试");
        },
      });
    });
    return;
  }

  // page 类型：有 path 则跳转指定页面，无 path 则返回上一页
  if (!path.trim()) {
    runInMiniProgram(mp, () => {
      console.log("[wxurl] 调用 navigateBack");
      mp.navigateBack({
        delta: 1,
        success: () => console.log("[wxurl] navigateBack 成功"),
        fail: (err) => {
          console.error("[wxurl] navigateBack 失败:", err.errMsg);
          toast.error("返回失败，请稍后重试");
        },
      });
    });
    return;
  }

  runInMiniProgram(mp, () => {
    console.log("[wxurl] 调用 navigateTo", url);
    mp.navigateTo({
      url,
      success: () => console.log("[wxurl] navigateTo 成功", url),
      fail: (err) => {
        console.error("[wxurl] navigateTo 失败:", err.errMsg);
        toast.error("跳转失败，请稍后重试");
      },
    });
  });
}
